export default __webpack_public_path__ + "static/RootSans-10BoldItalic-a2abd0194ca2005d954bebbff1ade894.woff";